import * as React from 'react';
import { IgcDateTimeInputComponent as Component } from 'igniteui-webcomponents';
import type { IgcDateTimeInputComponentEventMap } from 'igniteui-webcomponents';
import { type EventName, createComponent } from '../react-props.js';

/**
 * A date time input is an input field that lets you set and edit the date and time in a chosen input element
 * using customizable display and input formats.
 * @slot prefix - Renders content before the input.
 * @slot suffix - Renders content after input.
 * @slot helper-text - Renders content below the input.
 * @slot value-missing - Renders content when the required validation fails.
 * @slot range-overflow - Renders content when the max validation fails.
 * @slot range-underflow - Renders content when the min validation fails.
 * @slot custom-error - Renders content when setCustomValidity(message) is set.
 * @slot invalid - Renders content when the component is in invalid state (validity.valid = false).
 * @fires igcInput - Emitted when the control input receives user input.
 * @fires igcChange - Emitted when the control's checked state changes.
 * @csspart container - The main wrapper that holds all main input elements.
 * @csspart input - The native input element.
 * @csspart label - The native label element.
 * @csspart prefix - The prefix wrapper.
 * @csspart suffix - The suffix wrapper.
 * @csspart helper-text - The helper text wrapper.
 * @class
 */
export const IgrDateTimeInput = /* @__PURE__ */ createComponent({
  tagName: 'igc-date-time-input',
  displayName: 'IgrDateTimeInput',
  elementClass: Component,
  react: React,
  events: {
    onInput: 'igcInput' as EventName<
      IgcDateTimeInputComponentEventMap['igcInput']
    >,
    onChange: 'igcChange' as EventName<
      IgcDateTimeInputComponentEventMap['igcChange']
    >,
  },
});

export type IgrDateTimeInput = Component;

/** @deprecated Module register is no longer needed and can be removed */
export const IgrDateTimeInputModule = Component;
